import { createSelector } from 'reselect';

import { EMPLOYEE_ID } from 'utils/constants';

export const getCurrentUser = (state) => {
  const employeeID = localStorage.getItem(EMPLOYEE_ID);
  return state.users.byID[employeeID] ?? {};
};

export const getEmployees = (state) => Object.values(state.users.byID) || [];

export const getUsers = (state) =>
  Object.values(state.users.byID).filter((employee) => employee.userID) || [];

export const getUserGroups = (state) => state.users.userGroups || [];
export const getUserRights = (state) => state.users.userRights;

export const getCurrentUserIsAdmin = createSelector(
  getUserRights,
  (userRights) => {
    const settingsRights = userRights.modules.find(
      (right) => right.sectionName === 'settings',
    );
    return Boolean(settingsRights.view) ?? false;
  },
);

export const getCurrentUserHasRightToChangeVersion = createSelector(
  getUserRights,
  (userRights) => Boolean(userRights.rightChangePOSVersion),
);
